import { useGameStore, Transaction } from '@/store/gameStore'
import { SectionDeck, IconTile, EmptyStateRich } from '../components/CourtVision'
import { TrendingUp, TrendingDown, ArrowLeftRight, Receipt } from 'lucide-react'

export function EconomyTabContent() {
  const { totalIncome, totalExpenses, transactions, courts } = useGameStore()

  const recentTransactions = transactions.slice(-5).reverse()
  const projectedDailyIncome = courts.length > 0
    ? Math.floor(courts.length * 14 * 0.4 * 20)
    : 0
  const projectedWeeklyExpenses = courts.reduce((acc, court) =>
    acc + (court.type === 'outdoor' ? 50 : 100), 0
  )

  return (
    <div>
      <SectionDeck title="Flujo semanal" icon={ArrowLeftRight}>
        <div className="space-y-2">
          <div className="row-tile">
            <IconTile icon={TrendingUp} tone="success" />
            <div className="row-tile-main">
              <div className="row-tile-title">Ingresos</div>
              <div className="row-tile-sub">Proyección: ~{projectedDailyIncome.toLocaleString('es-ES')}€/día con las pistas actuales</div>
            </div>
            <div className="row-tile-side">
              <span className="money-positive" style={{ fontWeight: 700 }}>
                +{totalIncome.toLocaleString('es-ES')}€
              </span>
              <span className="meta-text">acumulado</span>
            </div>
          </div>

          <div className="row-tile">
            <IconTile icon={TrendingDown} tone="warning" />
            <div className="row-tile-main">
              <div className="row-tile-title">Gastos</div>
              <div className="row-tile-sub">Proyección: -{projectedWeeklyExpenses.toLocaleString('es-ES')}€/semana en mantenimiento</div>
            </div>
            <div className="row-tile-side">
              <span className="money-negative" style={{ fontWeight: 700 }}>
                -{totalExpenses.toLocaleString('es-ES')}€
              </span>
              <span className="meta-text">acumulado</span>
            </div>
          </div>
        </div>
      </SectionDeck>

      <SectionDeck title="Últimas transacciones" icon={Receipt} meta={recentTransactions.length > 0 ? `${recentTransactions.length} recientes` : undefined}>
        {recentTransactions.length === 0 ? (
          <EmptyStateRich
            icon={Receipt}
            title="La caja sigue en silencio"
            sub="En cuanto el club empiece a mover dinero, cada apunte aparecerá aquí"
          />
        ) : (
          <div className="space-y-1">
            {recentTransactions.map((t) => (
              <TransactionRow key={t.id} transaction={t} />
            ))}
          </div>
        )}
      </SectionDeck>
    </div>
  )
}

function TransactionRow({ transaction }: { transaction: Transaction }) {
  const isIncome = transaction.type === 'income'
  return (
    <div className="transaction-row">
      <span className="transaction-desc">{transaction.description}</span>
      <span
        className={isIncome ? 'money-positive' : 'money-negative'}
        style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}
      >
        {isIncome ? '+' : '-'}{transaction.amount.toLocaleString('es-ES')}€
      </span>
    </div>
  )
}
